import gql from "graphql-tag";

export default gql`
  mutation DeleteRTMP($eventId: ID, $componentName: String) {
    deleteRTMP(eventId: $eventId, componentName: $componentName) {
      id
    }
  }
`;
